<template>
  <el-select v-model="absenceType" placeholder="选择缺勤类型">
    <el-option
      v-for="item in absenceTypeArr"
      :key="item.value"
      :label="item.label"
      :value="item.label"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "TaskTypeSelect",
  props: {},
  data() {
    return {
      absenceType: "",
      absenceTypeArr: [
        {
          value: 1,
          label: "病假",
        },
        {
          value: 2,
          label: "事假",
        },
        {
          value: 3,
          label: "休假",
        },
        {
          value: 4,
          label: "迟到",
        },
        {
          value: 5,
          label: "早退",
        },
        {
          value: 6,
          label: "矿工",
        },
        {
          value: 7,
          label: "缺卡",
        },
      ],
    };
  },

  watch: {
    absenceType(newVal, oldVal) {
      this.$emit("absenceType", this.absenceType);
    },
  },
};
</script>

<style scoped lang="scss">
</style>